<template>
  <v-dialog :value="value" @input="$emit('input', $event)" maxWidth="800px" scrollable>
    <v-card>
      <v-card-title>
        <span class="headline">CV</span>
        <v-spacer />
        <tk-btn icon @click="$emit('input', !value)">
          <v-icon>fas fa-times</v-icon>
        </tk-btn>
      </v-card-title>

      <v-card-text :class="{'loading': loading}" style="min-height: 100px;">
        <table class="artist-cv">
          <tr v-if="cv.education">
            <th>{{ $t('CV.EDUCATION') }}</th>
            <td class="pre-wrap">{{ cv.education }}</td>
          </tr>
          <tr v-if="cv.memberships">
            <th>{{ $t('CV.MEMBERSHIPS') }}</th>
            <td class="pre-wrap">{{ cv.memberships }}</td>
          </tr>
          <tr v-if="cv.solo_exhibitions">
            <th>{{ $t('CV.SOLO_EXHIBITIONS') }}</th>
            <td class="pre-wrap">{{ cv.solo_exhibitions }}</td>
          </tr>
          <tr v-if="cv.group_exhibitions">
            <th>{{ $t('CV.GROUP_EXHIBITIONS') }}</th>
            <td class="pre-wrap">{{ cv.group_exhibitions }}</td>
          </tr>
          <tr v-if="cv.grants">
            <th>{{ $t('CV.GRANTS') }}</th>
            <td class="pre-wrap">{{ cv.grants }}</td>
          </tr>
          <tr v-if="cv.residences">
            <th>{{ $t('CV.RESIDENCES') }}</th>
            <td class="pre-wrap">{{ cv.residences }}</td>
          </tr>
          <tr v-if="cv.collections">
            <th>{{ $t('CV.COLLECTIONS') }}</th>
            <td class="pre-wrap">{{ cv.collections }}</td>
          </tr>
        </table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { RepositoryFactory } from "@/services/RepositoryFactory";
import { ErrorHandler } from "@/utils/ErrorHandler";

const artistsRepo = RepositoryFactory.artists();
const handler = new ErrorHandler();

export default {
  props: ["value", "id"],

  data() {
    return {
      cv: {},
      loading: false
    };
  },

  watch: {
    value: function(val) {
      if (val) this.fetchData();
    }
  },

  methods: {
    async fetchData() {
      console.log(this.cv);
      if (Object.keys(this.cv).length) return;
      this.loading = true;
      await handler.handle(async () => {
        this.cv = await artistsRepo.getCV(this.id);
      });
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
table.artist-cv {
  th {
    vertical-align: top;
    padding-top: 8px;
  }
  td {
    padding-left: 8px;
    padding-top: 8px;
  }
}
</style>
